"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var _HotelCheckoutContext = _interopRequireDefault(require("../../context/HotelCheckoutContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function useFootnote(name) {
  var _useContext = (0, _react.useContext)(_HotelCheckoutContext["default"]),
      footnotes = _useContext.footnotes;

  return footnotes && name ? footnotes[name] : footnotes;
}

var _default = useFootnote;
exports["default"] = _default;